export const REQUEST_ORG_FEATURES = 'orgFeatures/REQUEST_ORG_FEATURES';
export const SET_ORG_FEATURES = 'orgFeatures/SET_ORG_FEATURES';

export const GRANULAR_PERMISSIONS_FEATURE_ID = 27;
export const BADGE_PRINTING_FEATURE_ID = 60;
